export const NAME = 'organizationName'
export const PHONE_NUMBER = 'phone'
export const EMAIL = 'email'
export const SUB_END_DATA = 'subscriptionExpiration'
export const BLOCK_ORGANIZATION = 'blocked'
export const ORGANIZATION_NAME = 'organizationName'
